<template>
    <div>
        <b-modal
            :title="$t('Subscribe to Creator')"
            hide-footer
            v-model="modal"
            centered
            body-class="p-0"
            no-close-on-esc
            no-fade
            static
        >
            <subscribe-creator-create />
        </b-modal>
    </div>
</template>

<script>
import SubscribeCreatorCreate from "@/components/subscribeCreator/SubscribeCreatorCreate";

export default {
    computed: {
        modal: {
            get() {
                return this.$store.state.interface
                    .creatorSubscriptionModalVisible;
            },
            set(value) {
                this.$store.commit(
                    "interface/setCreatorSubscriptionModalVisible",
                    value
                );
            },
        },
    },
    components: {
        SubscribeCreatorCreate,
    },
};
</script>










